import { render } from "./voiceSampleCard.vue?vue&type=template&id=cd92279c"
import script from "./voiceSampleCard.vue?vue&type=script&lang=js"
export * from "./voiceSampleCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__